import { AccountFetchCache } from "@helium/account-fetch-cache";
import React, { createContext, useEffect, useMemo, useRef, } from "react";
export const AccountContext = createContext(undefined);
export function usePrevious(state) {
    const ref = useRef();
    useEffect(() => {
        ref.current = state;
    });
    return ref.current;
}
export const AccountProvider = ({ children, commitment = "confirmed", extendConnection = true, connection, }) => {
    const cache = useMemo(() => {
        return new AccountFetchCache({
            connection,
            delay: 50,
            commitment,
            extendConnection,
        });
    }, [connection]);
    const prevCache = usePrevious(cache);
    useEffect(() => {
        if (prevCache) {
            prevCache.close();
        }
    }, [prevCache]);
    return (React.createElement(AccountContext.Provider, { value: cache }, children));
    return null;
};
//# sourceMappingURL=accountContext.js.map